import { Box } from '@mui/material';
import AddRole from './add-role/AddRole';

const RolesPage: React.FC = () => {
  return (
    <Box sx={{
      height: '100%',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      bgcolor: 'background.default',
    }}>
      <AddRole />
    </Box>
  );
};

export default RolesPage;
